"use strict";

import Page from "./Settings.jsx";

export const auth = true;
export const title = "i18n:permits.permitters.settings.pageTitle";
export const Component = Page;
